<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

  html{
    font-family: 'Open Sans', sans-serif;
  }

  .alert-container {
    margin: 0 auto;
    margin-top: 50px;
    width: 20em;
    display: flex;
    flex-direction: column;
    text-align: center;
  /*   border: 1px solid black; */
    border-radius: 7px;
    -webkit-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.75);
    box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.75);
    background-color: #fafafa;
  /*   animation: fadeIn .5s; */
  /*     animation: fadeIn .5s; */
  /*   animation-fill-mode: forwards; */
  /*   visibility: hidden; */
  /*   transition: all 0.2s 0s ease; */
  }

  /* @keyframes fadeIn {
    0% {
      opacity 0;
    }
    100% {
      opavity 1;
    }
  } */

  .icon-container {
    z-index:10;
    padding: 90px 0;
    justify-content: center;
    display: flex;
    flex-direction: column;
    background-color: #fff;
  -webkit-box-shadow: 1px 3px 2px -1px rgba(153,150,153,1);
  -moz-box-shadow: 1px 3px 2px -1px rgba(153,150,153,1);
  box-shadow: 1px 3px 2px -1px rgba(153,150,153,1);
      
  }

  .response-text{
    padding-top: 25px;
    font-size: 30px;
  }

  .response-text.success{
    color: #5CBF85;
  }
  .response-text.error{
    color: #eb4034;
  }

  .message-container {
    padding: 50px 0;
    font-size: 18px;
  }

  .material-symbols-outlined {
    font-variation-settings:
    'FILL' 0,
    'wght' 200,
    'GRAD' 0,
    'opsz' 48
  }
</style>

<template>
  <div style="height: 100vh;">
    <!-- <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet"> -->
    <div v-if="loading" style="height:100%;display:flex;align-items: center">
      <Loader style="width: 10em;height: 10em;"></Loader>
    </div>
    <!-- <div v-else-if="(!loading && approved)" class="alert-container">
      <div class="icon-container">
        <span class="material-symbols-outlined" style="font-size: 150px; color: #5CBF85;">check_circle</span>
        <span class="response-text success">VERIFICADO</span>
      </div>
      <div class="message-container">
        <p>
          SU PROCESO HA SIDO VERIFICADO EXITOSAMENTE.
        </p>
      </div>
    </div> -->
    <!-- <div v-else-if="(!loading && !approved)" class="alert-container">
      <div class="icon-container">
        <span class="material-symbols-outlined" style="font-size: 150px; color: #eb4034;">cancel</span>
        <span class="response-text error">ERROR</span>
      </div>
      <div class="message-container">
        <p>
          HA OCURRIDO UN ERROR DURANTE EL PROCESO DE VERIFICACIÓN.
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
  import Loader from '../components/Loader';
  import axios from 'axios';

  export default {
    name: 'ThreeDSecure',
    components: { Loader },
    data:function(){
      return {
        loading: true,
        // approved: false,
      }
    },
    mounted() {
      const payment_intent = new URLSearchParams(document.location.search).get("payment_intent");

      axios({
        method: 'POST',
        url: `${process.env.VUE_APP_API_URL}app/checkThreeDSecure`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          payment_intent: payment_intent
        }
      }).then((resp)=>{
        console.log(resp.data.data.order_type)
        switch (resp.data.data.order_type) {
          case "PHONE_RECHARGE":
            axios({
              method: 'POST',
              url: `${process.env.VUE_APP_API_URL}app/purchasePhoneRechargeConfirm`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                payment_intent: payment_intent
              }
            }).then(()=>{
              this.loading = false;
              // if (resp.data.ok === true) {
              //   this.approved = true;
              // }
            }).catch(()=>{
              this.loading = false;
              // this.approved = false;
            });
            break;
          case "PAY_INVOICE":
            axios({
              method: 'POST',
              url: `${process.env.VUE_APP_API_URL}app/payInvoiceConfirm`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                payment_intent: payment_intent
              }
            }).then(()=>{
              this.loading = false;
              // if (resp.data.ok === true) {
              //   this.approved = true;
              // }
            }).catch(()=>{
              this.loading = false;
              // this.approved = false;
            });
            break;
          case "GIFTCARD":
            axios({
              method: 'POST',
              url: `${process.env.VUE_APP_API_URL}app/giftcardConfirm`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                payment_intent: payment_intent
              }
            }).then(()=>{
              this.loading = false;
              // if (resp.data.ok === true) {
              //   this.approved = true;
              // }
            }).catch(()=>{
              this.loading = false;
              // this.approved = false;
            });
            break
          default:
            axios({
              method: 'POST',
              url: `${process.env.VUE_APP_API_URL}app/confirmOrder`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                payment_intent: payment_intent
              }
            }).then(()=>{
              this.loading = false;
              // if (resp.data.ok === true) {
              //   this.approved = true;
              // }
            }).catch(()=>{
              this.loading = false;
              // this.approved = false;
            });
            break;
        }
        // if (resp.data.ok === true) {
        //   this.approved = true;
        // }
      }).catch(()=>{
        this.loading = false;
        // this.approved = false;
      });
    },
    
  }
</script>